import { useEffect, useState } from 'react';
import config from '../client/config';
import usePost from './usePost';
import { Variation } from '../utils/abTests';
import hasAnalyticsCookie from '../utils/hasAnalyticsCookie';

interface ABResponse {
  enrolledIn: Variation;
}

function useAbEnrol(slug: string, skip = false) {
  const url = `${config.abApiUrl}/abtests/${slug}/enrol`;
  const [enrolledInVariation, setEnrolledInVariation] = useState<Variation>(
    'A',
  );
  const [post, { data, error, loading }] = usePost<ABResponse>(url);

  useEffect(() => {
    if (hasAnalyticsCookie() && !skip) {
      post({ credentials: 'include', headers: {}, timeoutInMs: 4000 });
    }
  }, [post, skip]);

  useEffect(() => {
    if (error) {
      setEnrolledInVariation('A');
    }
  }, [error, slug]);

  useEffect(() => {
    if (!loading && data?.enrolledIn) {
      setEnrolledInVariation(data.enrolledIn);
    }
  }, [loading, data]);

  return { enrolledInVariation, loading };
}

export default useAbEnrol;
